const AffiliateRouteNavigationOptions = {
  title: 'Affiliate Program',
  headerTitle: 'Affiliate Program',
  headerBackVisible: false,
};

export default AffiliateRouteNavigationOptions;
